export const GET_LOG_PAYMENTS = 'GET_LOG_PAYMENTS';
export const GET_LOG_PAYMENTS_SUCCESS = 'GET_LOG_PAYMENTS_SUCCESS';
export const GET_LOG_PAYMENTS_FAILED = 'GET_LOG_PAYMENTS_FAILED';

export const GET_LOG_PAYMENT_BY_ID = 'GET_LOG_PAYMENT_BY_ID';
export const GET_LOG_PAYMENT_BY_ID_SUCCESS = 'GET_LOG_PAYMENT_BY_ID_SUCCESS';
export const GET_LOG_PAYMENT_BY_ID_FAILED = 'GET_LOG_PAYMENT_BY_ID_FAILED';

export const ADD_LOG_PAYMENTS = 'ADD_LOG_PAYMENTS';
export const ADD_LOG_PAYMENTS_SUCCESS = 'ADD_LOG_PAYMENTS_SUCCESS';
export const ADD_LOG_PAYMENTS_FAILED = 'ADD_LOG_PAYMENTS_FAILED';

export const UPDATE_LOG_PAYMENTS = 'UPDATE_LOG_PAYMENTS';
export const UPDATE_LOG_PAYMENTS_SUCCESS = 'UPDATE_LOG_PAYMENTS_SUCCESS';
export const UPDATE_LOG_PAYMENTS_FAILED = 'UPDATE_LOG_PAYMENTS_FAILED';

export const DELETE_LOG_PAYMENTS = 'DELETE_LOG_PAYMENTS';
export const DELETE_LOG_PAYMENTS_SUCCESS = 'DELETE_LOG_PAYMENTS_SUCCESS';
export const DELETE_LOG_PAYMENTS_FAILED = 'DELETE_LOG_PAYMENTS_FAILED';
